import api from "./api";
class CampanhaService {
    static async salvar(campanha) {
        const url = "/restrito/campanhas";
        const res = await api.post(url, campanha);
        return res.data;
    }
    static async getMinhasCampanhas() {
        const url = "/restrito/campanhas/lista-minhas-campanhas";
        const res = await api.get(url);
        return res.data;
    }
    static async show(campanha_id) {
        const url = "/restrito/campanhas/" + campanha_id;
        const res = await api.get(url);
        return res.data;
    }
}
export default CampanhaService;
